export default function showStatus (message, duration, type) {
  console.log(message, duration, type, new Date().getTime())
  // self.$store.commit('liveData/set_statusMessage', message)
  // self.$store.commit('liveData/set_statusDuration', duration)
  // self.$store.commit('liveData/set_statusType', type)
  // self.$store.commit('liveData/set_snackbar', true)
}
